// extracted by mini-css-extract-plugin
export var dateLabel = "_2m-0";
export var dateLabelError = "_2m-1";
export var fullWidth = "_2m-2";
export var smaller = "_2m-3";